import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import clsx from 'clsx';

const FormSection = ({
  emoji,
  title,
  isCompleted = false,
  percentage = 0,
  isValid = true,
  isOptional = false,
  delay = '0s',
  children,
  className = '',
}) => {
  const renderPercentage = () => {
    const shouldShowCheckbox = isCompleted && isValid;

    return (
      <div className={clsx('percentage', {
        'as-checkbox': shouldShowCheckbox,
        'as-text': !shouldShowCheckbox,
      })}>
        {shouldShowCheckbox ? (
          <div className="check-circle">
            <FontAwesomeIcon icon={faCheck} />
          </div>
        ) : (
          <div className="w-6 h-6 rounded-full bg-[#FF2E6C]" />
        )}
      </div>
    );
  };

  return (
    <div className={clsx('form-section', className)} style={{ '--delay': delay }}>
      <div className="section-header">
        <div className="section-title">
          <span className="emoji">{emoji}</span>
          <span className={clsx({ '!text-[#FF2E6C]': (!isCompleted || !isValid) && !isOptional })}>
            {title}
          </span>
        </div>
        {isOptional ? (
          <span className="text-gray-400 text-xl geomanistRegular font-semibold">
            Optionnel
          </span>
        ) : (
          renderPercentage()
        )}
      </div>
      {children}
    </div>
  );
};

export default FormSection;
